import React from 'react';

import type { FilterType } from './Filter';

type FilterSelectInputProps = {
  filters: string[];
  filter: string;
  filterType: FilterType;
  handleSelectFilter: (filter: string) => void;
};

function FilterSelectInput({
  filters,
  filter,
  filterType,
  handleSelectFilter,
}: FilterSelectInputProps) {
  const handleFilterSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { options, selectedIndex } = e.target;
    const filterValue = options[selectedIndex].value;

    handleSelectFilter(filterValue);
  };

  return (
    <div style={{ marginBottom: '1rem', whiteSpace: 'pre', overflowX: 'auto' }}>
      <label>
        <span className="screen-reader-text">Filter displayed {filterType}</span>
        <select style={{ width: '100%' }} value={filter} onChange={handleFilterSelectChange}>
          {filters.map((group) => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default FilterSelectInput;
